import VProgressLinear from './VProgressLinear'

/* istanbul ignore next */
VProgressLinear.install = function install (Vue) {
  Vue.component(VProgressLinear.name, VProgressLinear)
}

export default VProgressLinear



// WEBPACK FOOTER //
// ./src/components/VProgressLinear/index.js